<template>
  <path
    fill="currentColor"
    d="M5 11H11H13H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H13H11H5C4.44772 13 4 12.5523 4 12C4 11.4477 4.44772 11 5 11Z"
  />
</template>
